import { getRefundStatusLabel as getRefundStatusLabelFromConstants } from '../constants/refund-status';

/**
 * Gets the display label for a refund status ID
 * @param {number} statusId - The refund status ID (1-7)
 * @returns {string|null} The formatted status label or null if no status
 */
export const getRefundStatusLabel = getRefundStatusLabelFromConstants;

/**
 * Formats a refund date string to MM/DD/YYYY format
 * @param {string} dateString - ISO date string
 * @returns {string|null} Formatted date or null if no date
 */
export const formatRefundDate = (dateString) => {
  if (!dateString) return '-';

  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
      return '-';
    }
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    });
  } catch {
    return '-';
  }
};

/**
 * Formats a refund amount as currency
 * @param {number} amount - The amount to format
 * @returns {string|null} Formatted currency string or null if no amount
 */
export const formatRefundCurrency = (amount) => {
  if (amount === null || amount === undefined) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
};
